export default "__VITE_ASSET__CFzHC6CZ__"